<template>

  <div class="container">

    <BreadcrumSection :part1="$t('Titulacions')"></BreadcrumSection>

    <h1>{{ $t("Titulacions") }}</h1>

    <div v-if="totalElements === 0" class="alert alert-danger rounded-0" role="alert">
      {{ $t("No results") }}
    </div>

    <div v-else class="row">

      <div class="col-sm-12 col-md-8" >

        <div class="row">
          <div class="col-sm-12 col-md-8">
            <PaginationTable
                class="container"
                :show-pagination="true"
                v-model:current-page="currentPage"
                v-model:page-size="pageSize"
                :total="totalElements"
                :handle-current-change="handleCurrentChange">
            </PaginationTable>
          </div>

          <div class="col-sm-12 col-md-4">
            <div class="form-control-sm">
              <div class="d-flex align-items-center justify-content-end">
                <label class="form-check-label me-1" for="selectOrderBy">{{ $t("Ordenació") }}:</label>
                <select class="form-select form-select-sm select-auto-width" @change="handleOrderChange(selectedOrder)" v-model="selectedOrder" id="selectOrderBy">
                  <option value="titulacio_sigles asc" selected>{{$t('Sigles')}} asc.</option>
                  <option value="titulacio_sigles desc">{{$t('Sigles')}} desc.</option>
                  <option value="titulacio_nom_ca asc">{{$t('Nom')}} asc.</option>
                  <option value="titulacio_nom_ca desc">{{$t('Nom')}} desc.</option>
                </select>
              </div>
            </div>
          </div>

        </div>


        <ul class="list-group list-group-flush mt-1" >
          <li>
            <router-link-locale
                v-for="(titulacio) in response.titulacions"
                :key="titulacio.id"
                :to="{name: 'titulacio', params: {id: titulacio.id, listPage: currentPage, listSort: selectedOrder}}"
                class="list-group-item list-group-item-action flex-column align-items-start p-2"
                tag="li"
            >

              <div class="mb-1 d-flex w-100 justify-content-between">
                <span v-if="titulacio[`titulacio_nom_${locale}`]" class="text-blue">{{ titulacio[`titulacio_nom_${locale}`] }}</span>
                <span v-else class="text-blue">{{ titulacio.titulacio_nom_ca }}</span>
                <span class="text-secondary">
                  <span v-if="titulacio.titulacio_activa" class="badge bg-success">{{ $t("Activa") }}</span>
                  <span v-else class="badge bg-danger">{{ $t("No activo") }}</span>
                </span>

              </div>

              <div class="fw-bolder mb-1">
                <span>{{ titulacio.titulacio_sigles }}</span>
              </div>

              <div class="mb-1 text-secondary">
                <span>{{ $t(titulacio.titulacio_centre) }}</span>
              </div>

              <div class="mb-1 color-vermell fw-bolder">
                <span>{{ titulacio.titulacio_nivell }}</span>
              </div>


            </router-link-locale>
          </li>
        </ul>

        <PaginationTable
            class="container mt-3"
            :show-pagination="true"
            v-model:current-page="currentPage"
            v-model:page-size="pageSize"
            :total="totalElements"
            :handle-current-change="handleCurrentChange">
        </PaginationTable>

      </div>

      <div v-if="response.facetes" id="filtres" class="col-sm-12 col-md-4 mt-0">
        <FacetesFilter :data="response.facetes"  @apply-filter="handleApplyFilter" split-index="2" :marc="true"></FacetesFilter>
      </div>

    </div>

  </div>

</template>

<script>

import {computed, onMounted, ref} from "vue";
  import store from "@/store";
  import BreadcrumSection from "@/components/sections/BreadcrumbSection.vue";
  import RouterLinkLocale from "@/components/RouterLinkLocale.vue";
  import PaginationTable from "@/components/PaginationTable.vue";
  import FacetesFilter from "@/components/FacetesFilter.vue";
import {useI18n} from "vue-i18n";
import {useRoute, useRouter} from "vue-router";
import {setMetadata} from "@/composables/metadataFunctions";
import {
  createHandleApplyFilter,
  createHandleCurrentChange,
  createHandleOrderChange,
  getTitulacions
} from "@/composables/pageFunctions";
import {usePageWatcher, useQueryWatcher, useSortWatcher} from "@/composables/useWatchers";


  export default {
    name: "TitulacionsView",
    components: {FacetesFilter, PaginationTable, RouterLinkLocale, BreadcrumSection},

    setup(){
      const { locale } = useI18n();
      const response = ref([]);

      const query = ref("tipus:titulacio")
      const initQuery = query.value
      const currentPage = ref(1);
      const totalElements = ref(1)
      const pageSize = computed(() => { return store.getters.pageSize})
      const selectedOrder = ref("titulacio_sigles asc");

      const route = useRoute();
      const router = useRouter();
      const { t } = useI18n();

      onMounted(async () => {
        setMetadata(t('Titulacions'))
        await store.dispatch('updateSearchSelected', "Titulació");
        await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-red.webp') });
        currentPage.value = parseInt(route.params.page) || 1;
        const result = await getTitulacions(currentPage.value, store.getters.pageSize, query.value, route.params.sort, route.query)
        response.value = result
        totalElements.value = result.total
      });

      const handleCurrentChange = createHandleCurrentChange("titulacions", router, route);
      const handleOrderChange = createHandleOrderChange("titulacions", router, route, currentPage);

      usePageWatcher(getTitulacions, currentPage, response, totalElements, query, route, store);
      useSortWatcher(getTitulacions, currentPage, response, totalElements, query, route, store);
      useQueryWatcher(getTitulacions, currentPage, response, totalElements, query, route, store);

      const handleApplyFilter = async (newQuery) => {
        await createHandleApplyFilter({
          newQuery,
          callFunction:getTitulacions,
          currentPage,
          query,
          initQuery,
          response,
          totalElements,
          route,
          store
        });
      };

      return{
        response,
        query,
        locale,

        selectedOrder,
        currentPage,
        totalElements,
        pageSize,

        handleCurrentChange,
        handleApplyFilter,
        handleOrderChange
      }

    }


  }

</script>

<style scoped>

</style>
